const article = {
    id: 'order-csv-status',
    title: 'CSV status on orders',
    summary: 'The orders list now shows whether each order’s CSV is still pending or already consumed.',
    publishedAt: '2026-09-22',
    tags: ['orders', 'csv'],
    sections: [
        {
            type: 'paragraph',
            text: 'Dashboard orders have a CSV column next to the other stage columns. It uses the same pending and completed counts as the rest of the order snapshot, with completed labeled consumed.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it when you need to see, without opening the order, whether inbound CSV data is still waiting or has been consumed.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Dashboard.',
                'Find the CSV column on the orders table.',
                'Read the pending and consumed counts for that order.',
                'Hover the counts if you need the snapshot time.',
            ],
        },
    ],
};

export default article;
